import { render } from "./Dress.vue?vue&type=template&id=4d70846e&scoped=true"
import script from "./Dress.vue?vue&type=script&lang=js"
export * from "./Dress.vue?vue&type=script&lang=js"

import "./Dress.vue?vue&type=style&index=0&id=4d70846e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d70846e"]])

export default __exports__